import { Table } from "common/Table/Table"
import { useRouter } from "hooks/useRouter"
import queryString from "query-string"
import { useEffect, useState } from "react"
import UserService from "services/user.service"
import { exportToCSV } from "utils/funcs"
import { DEFAULT_SEASON_YEAR } from "utils/seasonYear"

const service = new UserService()

function parseRegisteredUsersParams(search: string) {
  const q = queryString.parse(search)
  return {
    pageNumber: Number(q.pageNumber) || 1,
    pageSize: Number(q.pageSize) || 100,
    name: String(q.name ?? ""),
    state: String(q.state ?? ""),
    startDate: String(q.startDate ?? ""),
    endDate: String(q.endDate ?? ""),
    blitzMonth: String(q.blitzMonth ?? ""),
    badgeId: String(q.badgeId ?? ""),
    salesYear: String(q.salesYear ?? DEFAULT_SEASON_YEAR),
  }
}

export const RegisteredUsers = () => {
  const { push, location } = useRouter()
  const [pagination, setPagination] = useState(() =>
    parseRegisteredUsersParams(location.search)
  )
  const [loading, setLoading] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [registeredUsers, setRegisteredUsers] = useState<any>([])

  const [totalItems, setTotalItems] = useState(0)

  useEffect(() => {
    setPagination(parseRegisteredUsersParams(location.search))
  }, [location.search])

  useEffect(() => {
    setLoading(true)
    service
      .getRegisteredBlitz(pagination)
      .then((resp) => {
        setRegisteredUsers(resp.data.data ?? [])
        setTotalItems(resp.data.totalDocument ?? 0)
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoading(false)
      })
  }, [pagination])

  const handleExport = async () => {
    setExporting(true)
    try {
      const resp = await service.getRegisteredBlitz({
        ...pagination,
        isDownload: "true",
      })
      exportToCSV(resp.data.data ?? [], "registered-blitz-users")
    } catch (e) {
      console.error(e)
    } finally {
      setExporting(false)
    }
  }

  const columns = [
    { key: "first name", title: "first name", dbColName: "first_name" },
    { key: "last name", title: "last name", dbColName: "last_name" },
    { key: "badge id", title: "badge id", dbColName: "badge_id" },
    { key: "phone number", title: "phone number", dbColName: "phone_number" },
    {
      key: "rep start date",
      title: "rep start date",
      dbColName: "rep_start_date",
    },
    { key: "rep end date", title: "rep end date", dbColName: "rep_end_date" },
    {
      key: "tenure registered",
      title: "tenure registered",
      dbColName: "tenure_registered",
    },
    { key: "position", title: "position", dbColName: "position" },
    { key: "max position", title: "max position", dbColName: "max position" },
    { key: "sales year", title: "sales year", dbColName: "sales_year" },
  ]

  return (
    <div>
      <div className="flex gap-4 items-start">
        <button
          type="button"
          onClick={() => push("/blitz")}
          className="bg-white rounded-md p-2 border"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
            />
          </svg>
        </button>
        <div className="flex flex-col mb-4">
          <h1 className="page-title">
            Registered Users
          </h1>
          <p className="page-subtitle">View all Registered users</p>
        </div>
      </div>
      <Table
        loadingData={loading}
        columns={columns}
        data={registeredUsers}
        totalItems={totalItems}
        pagination={pagination}
        setPagination={setPagination}
        exportButton={true}
        handleExport={handleExport}
        exporting={exporting}
      />
    </div>
  )
}
